/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Spinner from "components/spinner/spinner";
import Plus from "components/icons/plus";
import Button from "components/button/button";
import Close from "components/icons/close";
import { LoaderState } from "behaviors/loader/state";
import { TimeoutError } from "api/errors";
import { EntitiesNotFoundError } from "./errors";
import { t } from "i18n";

interface LoaderProps {
  loader: LoaderState;
  fetchEntities: () => void;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error }, fetchEntities }) => {
  if (loading) {
    return <Spinner message={t("entities.loading")} />;
  }
  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <Plus width="48" height="48" />
          <p>{t("entities.could_not_load_list")}</p>
          <p>
            <Button onClick={fetchEntities}>{t("entities.retry")}</Button>
          </p>
        </React.Fragment>
      );
    }

    if (error instanceof EntitiesNotFoundError) {
      return (
        <React.Fragment>
          <Close width="48" height="48" />
          <p>{t("entities.not_found")}</p>
        </React.Fragment>
      );
    }
  }

  return <p>Unknown error</p>;
};

export default Loader;
